import { render, staticRenderFns } from "./ItemAuthorItemMenu.vue?vue&type=template&id=74bbaa71"
import script from "./ItemAuthorItemMenu.vue?vue&type=script&lang=ts"
export * from "./ItemAuthorItemMenu.vue?vue&type=script&lang=ts"
import style0 from "./ItemAuthorItemMenu.vue?vue&type=style&index=0&id=74bbaa71&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports